export const events = [
    {
        name: 'trace',
        parameters: [
            {
                type: 'Integer',
                name: 'line',
                decimals: 0,
            },
        ],
    },
    {
        name: 'error',
        parameters: [
            {
                type: 'Integer',
                name: 'line',
                decimals: 0,
            },
            {
                type: 'String',
                name: 'message',
            },
        ],
    },
    {
        name: 'console.log',
        parameters: [
            {
                type: 'Integer',
                name: 'line',
                decimals: 0,
            },
            {
                type: 'Buffer',
                name: 'args',
            },
        ],
    },
];

//# sourceMappingURL=trace.js.map
